/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  InvalidateQueryFilters,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  OperationInfiniteData,
  PartialParameters,
  QraftServiceOperationsToken,
  QueryFiltersByParameters,
  QueryFiltersByQueryKey,
  QueryFnOptionsByParameters,
  QueryFnOptionsByQueryKey,
  RequestFnResponse,
  ServiceOperationEnsureInfiniteQueryDataOptions,
  ServiceOperationEnsureQueryDataOptions,
  ServiceOperationFetchInfiniteQueryOptions,
  ServiceOperationFetchQueryOptions,
  ServiceOperationInfiniteQueryKey,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationQueryKey,
  ServiceOperationUseMutationOptions,
  UseQueryOptionsForUseQueries,
  UseQueryOptionsForUseSuspenseQuery,
  WithOptional,
} from '@openapi-qraft/tanstack-query-react-types';
import type {
  CancelOptions,
  DefinedInitialDataInfiniteOptions,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteQueryPageParamsOptions,
  InvalidateOptions,
  Mutation,
  MutationCache,
  MutationState,
  NoInfer,
  QueryState,
  RefetchOptions,
  ResetOptions,
  SetDataOptions,
  UndefinedInitialDataInfiniteOptions,
  UndefinedInitialDataOptions,
  Updater,
  UseInfiniteQueryResult,
  UseMutationResult,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type { paths } from '../schema';

export interface SchedulingService {
  /**
   * @summary Submit
   * @description Submit a new scheduling job.
   *
   * Date validation is performed by SchedulingJobParams schema.
   * In-progress check is performed by submit_scheduling_job service.
   */
  submitSchedulingJobsPost: {
    /**
     * @summary Submit
     * @description Submit a new scheduling job.
     *
     * Date validation is performed by SchedulingJobParams schema.
     * In-progress check is performed by submit_scheduling_job service.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        SubmitSchedulingJobsPostBody,
        SubmitSchedulingJobsPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: SubmitSchedulingJobsPostSchema,
        options: ServiceOperationMutationFnOptions<
          SubmitSchedulingJobsPostBody,
          SubmitSchedulingJobsPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<RequestFnResponse<SubmitSchedulingJobsPostData, SubmitSchedulingJobsPostError>>
    ): Promise<RequestFnResponse<SubmitSchedulingJobsPostData, SubmitSchedulingJobsPostError>>;
    /**
     * @summary Submit
     * @description Submit a new scheduling job.
     *
     * Date validation is performed by SchedulingJobParams schema.
     * In-progress check is performed by submit_scheduling_job service.
     */
    getMutationKey(
      parameters: DeepReadonly<SubmitSchedulingJobsPostParameters> | void
    ): ServiceOperationMutationKey<SubmitSchedulingJobsPostSchema, SubmitSchedulingJobsPostParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Submit
     * @description Submit a new scheduling job.
     *
     * Date validation is performed by SchedulingJobParams schema.
     * In-progress check is performed by submit_scheduling_job service.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.schedulingService.submitSchedulingJobsPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.schedulingService.submitSchedulingJobsPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends SubmitSchedulingJobsPostBody, TContext = unknown>(
      parameters: DeepReadonly<SubmitSchedulingJobsPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        SubmitSchedulingJobsPostSchema,
        SubmitSchedulingJobsPostData,
        SubmitSchedulingJobsPostParameters,
        TVariables,
        OperationError<SubmitSchedulingJobsPostError>,
        TContext
      >
    ): UseMutationResult<
      SubmitSchedulingJobsPostData,
      OperationError<SubmitSchedulingJobsPostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Submit
     * @description Submit a new scheduling job.
     *
     * Date validation is performed by SchedulingJobParams schema.
     * In-progress check is performed by submit_scheduling_job service.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.schedulingService.submitSchedulingJobsPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.schedulingService.submitSchedulingJobsPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<SubmitSchedulingJobsPostBody, SubmitSchedulingJobsPostParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        SubmitSchedulingJobsPostSchema,
        SubmitSchedulingJobsPostData,
        SubmitSchedulingJobsPostParameters,
        TVariables,
        OperationError<SubmitSchedulingJobsPostError>,
        TContext
      >
    ): UseMutationResult<
      SubmitSchedulingJobsPostData,
      OperationError<SubmitSchedulingJobsPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Submit
     * @description Submit a new scheduling job.
     *
     * Date validation is performed by SchedulingJobParams schema.
     * In-progress check is performed by submit_scheduling_job service.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const submitSchedulingJobsPostTotal = qraft.schedulingService.submitSchedulingJobsPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const submitSchedulingJobsPostTotal = qraft.schedulingService.submitSchedulingJobsPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            SubmitSchedulingJobsPostBody,
            SubmitSchedulingJobsPostData,
            SubmitSchedulingJobsPostParameters,
            OperationError<SubmitSchedulingJobsPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SubmitSchedulingJobsPostSchema,
            SubmitSchedulingJobsPostBody,
            SubmitSchedulingJobsPostData,
            SubmitSchedulingJobsPostParameters,
            OperationError<SubmitSchedulingJobsPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Submit
     * @description Submit a new scheduling job.
     *
     * Date validation is performed by SchedulingJobParams schema.
     * In-progress check is performed by submit_scheduling_job service.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const submitSchedulingJobsPostPendingMutationVariables = qraft.schedulingService.submitSchedulingJobsPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const submitSchedulingJobsPostMutationData = qraft.schedulingService.submitSchedulingJobsPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        SubmitSchedulingJobsPostData,
        OperationError<SubmitSchedulingJobsPostError>,
        MutationVariables<SubmitSchedulingJobsPostBody, SubmitSchedulingJobsPostParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            SubmitSchedulingJobsPostBody,
            SubmitSchedulingJobsPostData,
            SubmitSchedulingJobsPostParameters,
            OperationError<SubmitSchedulingJobsPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SubmitSchedulingJobsPostSchema,
            SubmitSchedulingJobsPostBody,
            SubmitSchedulingJobsPostData,
            SubmitSchedulingJobsPostParameters,
            OperationError<SubmitSchedulingJobsPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          SubmitSchedulingJobsPostData,
          OperationError<SubmitSchedulingJobsPostError>,
          MutationVariables<SubmitSchedulingJobsPostBody, SubmitSchedulingJobsPostParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Submit
     * @description Submit a new scheduling job.
     *
     * Date validation is performed by SchedulingJobParams schema.
     * In-progress check is performed by submit_scheduling_job service.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            SubmitSchedulingJobsPostBody,
            SubmitSchedulingJobsPostData,
            SubmitSchedulingJobsPostParameters,
            OperationError<SubmitSchedulingJobsPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SubmitSchedulingJobsPostSchema,
            SubmitSchedulingJobsPostBody,
            SubmitSchedulingJobsPostData,
            SubmitSchedulingJobsPostParameters,
            OperationError<SubmitSchedulingJobsPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Submit
     * @description Submit a new scheduling job.
     *
     * Date validation is performed by SchedulingJobParams schema.
     * In-progress check is performed by submit_scheduling_job service.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.schedulingService.submitSchedulingJobsPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.schedulingService.submitSchedulingJobsPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              SubmitSchedulingJobsPostBody,
              SubmitSchedulingJobsPostData,
              SubmitSchedulingJobsPostParameters,
              OperationError<SubmitSchedulingJobsPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              SubmitSchedulingJobsPostSchema,
              SubmitSchedulingJobsPostBody,
              SubmitSchedulingJobsPostData,
              SubmitSchedulingJobsPostParameters,
              OperationError<SubmitSchedulingJobsPostError>,
              TContext
            >
      ):
        | Mutation<
            SubmitSchedulingJobsPostData,
            SubmitSchedulingJobsPostError,
            MutationVariables<SubmitSchedulingJobsPostBody, SubmitSchedulingJobsPostParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              SubmitSchedulingJobsPostBody,
              SubmitSchedulingJobsPostData,
              SubmitSchedulingJobsPostParameters,
              OperationError<SubmitSchedulingJobsPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              SubmitSchedulingJobsPostSchema,
              SubmitSchedulingJobsPostBody,
              SubmitSchedulingJobsPostData,
              SubmitSchedulingJobsPostParameters,
              OperationError<SubmitSchedulingJobsPostError>,
              TContext
            >
      ): Array<
        Mutation<
          SubmitSchedulingJobsPostData,
          SubmitSchedulingJobsPostError,
          MutationVariables<SubmitSchedulingJobsPostBody, SubmitSchedulingJobsPostParameters>,
          TContext
        >
      >;
    };
    schema: SubmitSchedulingJobsPostSchema;
    types: {
      parameters: SubmitSchedulingJobsPostParameters;
      data: SubmitSchedulingJobsPostData;
      error: SubmitSchedulingJobsPostError;
      body: SubmitSchedulingJobsPostBody;
    };
  };
  /**
   * @summary Get Latest
   * @description Get the most recent scheduling job for the office.
   */
  getLatestSchedulingJobsLatestGet: {
    /**
     * @summary Get Latest
     * @description Get the most recent scheduling job for the office.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            GetLatestSchedulingJobsLatestGetSchema,
            GetLatestSchedulingJobsLatestGetParameters,
            TMeta,
            TSignal
          >
        | (QueryFnOptionsByParameters<GetLatestSchedulingJobsLatestGetParameters, TMeta, TSignal> | void),
      client?: (
        schema: GetLatestSchedulingJobsLatestGetSchema,
        options: {
          parameters: GetLatestSchedulingJobsLatestGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<GetLatestSchedulingJobsLatestGetData, GetLatestSchedulingJobsLatestGetError>>
    ): Promise<RequestFnResponse<GetLatestSchedulingJobsLatestGetData, GetLatestSchedulingJobsLatestGetError>>;
    /**
     * @summary Get Latest
     * @description Get the most recent scheduling job for the office.
     */
    getQueryKey(
      parameters: DeepReadonly<GetLatestSchedulingJobsLatestGetParameters> | void
    ): ServiceOperationQueryKey<GetLatestSchedulingJobsLatestGetSchema, GetLatestSchedulingJobsLatestGetParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Latest
     * @description Get the most recent scheduling job for the office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.schedulingService.getLatestSchedulingJobsLatestGet.useQuery()
     * ```
     */
    useQuery<TData = GetLatestSchedulingJobsLatestGetData>(
      parameters:
        | ServiceOperationQueryKey<GetLatestSchedulingJobsLatestGetSchema, GetLatestSchedulingJobsLatestGetParameters>
        | (DeepReadonly<GetLatestSchedulingJobsLatestGetParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          GetLatestSchedulingJobsLatestGetData,
          GetLatestSchedulingJobsLatestGetError,
          TData,
          ServiceOperationQueryKey<GetLatestSchedulingJobsLatestGetSchema, GetLatestSchedulingJobsLatestGetParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetLatestSchedulingJobsLatestGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Latest
     * @description Get the most recent scheduling job for the office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.schedulingService.getLatestSchedulingJobsLatestGet.useQuery()
     * ```
     */
    useQuery<TData = GetLatestSchedulingJobsLatestGetData>(
      parameters:
        | ServiceOperationQueryKey<GetLatestSchedulingJobsLatestGetSchema, GetLatestSchedulingJobsLatestGetParameters>
        | (DeepReadonly<GetLatestSchedulingJobsLatestGetParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          GetLatestSchedulingJobsLatestGetData,
          GetLatestSchedulingJobsLatestGetError,
          TData,
          ServiceOperationQueryKey<GetLatestSchedulingJobsLatestGetSchema, GetLatestSchedulingJobsLatestGetParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetLatestSchedulingJobsLatestGetError>>;
    /**
     * @summary Get Latest
     * @description Get the most recent scheduling job for the office.
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetLatestSchedulingJobsLatestGetParameters> | void
    ): ServiceOperationInfiniteQueryKey<
      GetLatestSchedulingJobsLatestGetSchema,
      GetLatestSchedulingJobsLatestGetParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Latest
     * @description Get the most recent scheduling job for the office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.schedulingService.getLatestSchedulingJobsLatestGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetLatestSchedulingJobsLatestGetParameters,
      TQueryFnData = GetLatestSchedulingJobsLatestGetData,
      TData = OperationInfiniteData<TQueryFnData, GetLatestSchedulingJobsLatestGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetLatestSchedulingJobsLatestGetSchema,
            GetLatestSchedulingJobsLatestGetParameters
          >
        | (DeepReadonly<GetLatestSchedulingJobsLatestGetParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetLatestSchedulingJobsLatestGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetLatestSchedulingJobsLatestGetSchema,
            GetLatestSchedulingJobsLatestGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetLatestSchedulingJobsLatestGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Latest
     * @description Get the most recent scheduling job for the office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.schedulingService.getLatestSchedulingJobsLatestGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetLatestSchedulingJobsLatestGetParameters,
      TQueryFnData = GetLatestSchedulingJobsLatestGetData,
      TData = OperationInfiniteData<TQueryFnData, GetLatestSchedulingJobsLatestGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetLatestSchedulingJobsLatestGetSchema,
            GetLatestSchedulingJobsLatestGetParameters
          >
        | (DeepReadonly<GetLatestSchedulingJobsLatestGetParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetLatestSchedulingJobsLatestGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetLatestSchedulingJobsLatestGetSchema,
            GetLatestSchedulingJobsLatestGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetLatestSchedulingJobsLatestGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetLatestSchedulingJobsLatestGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get Latest
     * @description Get the most recent scheduling job for the office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getLatestSchedulingJobsLatestGetTotal = qraft.schedulingService.getLatestSchedulingJobsLatestGet.useIsFetching()
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetLatestSchedulingJobsLatestGetSchema,
            GetLatestSchedulingJobsLatestGetData,
            TInfinite,
            GetLatestSchedulingJobsLatestGetParameters,
            GetLatestSchedulingJobsLatestGetError
          >
        | QueryFiltersByQueryKey<
            GetLatestSchedulingJobsLatestGetSchema,
            GetLatestSchedulingJobsLatestGetData,
            TInfinite,
            GetLatestSchedulingJobsLatestGetParameters,
            GetLatestSchedulingJobsLatestGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get Latest
     * @description Get the most recent scheduling job for the office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getLatestSchedulingJobsLatestGetResults = qraft.schedulingService.getLatestSchedulingJobsLatestGet.useQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getLatestSchedulingJobsLatestGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getLatestSchedulingJobsLatestGetCombinedResults = qraft.schedulingService.getLatestSchedulingJobsLatestGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getLatestSchedulingJobsLatestGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetLatestSchedulingJobsLatestGetSchema,
          GetLatestSchedulingJobsLatestGetParameters,
          GetLatestSchedulingJobsLatestGetData,
          GetLatestSchedulingJobsLatestGetError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<GetLatestSchedulingJobsLatestGetData, GetLatestSchedulingJobsLatestGetError>
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<UseQueryResult<GetLatestSchedulingJobsLatestGetData, GetLatestSchedulingJobsLatestGetError>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get Latest
     * @description Get the most recent scheduling job for the office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.schedulingService.getLatestSchedulingJobsLatestGet.useSuspenseQuery()
     * ```
     */
    useSuspenseQuery<TData = GetLatestSchedulingJobsLatestGetData>(
      parameters:
        | ServiceOperationQueryKey<GetLatestSchedulingJobsLatestGetSchema, GetLatestSchedulingJobsLatestGetParameters>
        | (DeepReadonly<GetLatestSchedulingJobsLatestGetParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          GetLatestSchedulingJobsLatestGetData,
          GetLatestSchedulingJobsLatestGetError,
          TData,
          ServiceOperationQueryKey<GetLatestSchedulingJobsLatestGetSchema, GetLatestSchedulingJobsLatestGetParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetLatestSchedulingJobsLatestGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get Latest
     * @description Get the most recent scheduling job for the office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.schedulingService.getLatestSchedulingJobsLatestGet.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends GetLatestSchedulingJobsLatestGetParameters,
      TData = GetLatestSchedulingJobsLatestGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetLatestSchedulingJobsLatestGetSchema,
            GetLatestSchedulingJobsLatestGetParameters
          >
        | (DeepReadonly<GetLatestSchedulingJobsLatestGetParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetLatestSchedulingJobsLatestGetData,
          GetLatestSchedulingJobsLatestGetError,
          OperationInfiniteData<TData, GetLatestSchedulingJobsLatestGetParameters>,
          ServiceOperationInfiniteQueryKey<
            GetLatestSchedulingJobsLatestGetSchema,
            GetLatestSchedulingJobsLatestGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetLatestSchedulingJobsLatestGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetLatestSchedulingJobsLatestGetParameters>,
      OperationError<GetLatestSchedulingJobsLatestGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get Latest
     * @description Get the most recent scheduling job for the office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getLatestSchedulingJobsLatestGetData = qraft.schedulingService.getLatestSchedulingJobsLatestGet.useSuspenseQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getLatestSchedulingJobsLatestGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getLatestSchedulingJobsLatestGetCombinedData = qraft.schedulingService.getLatestSchedulingJobsLatestGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getLatestSchedulingJobsLatestGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetLatestSchedulingJobsLatestGetSchema,
          GetLatestSchedulingJobsLatestGetParameters,
          GetLatestSchedulingJobsLatestGetData,
          GetLatestSchedulingJobsLatestGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<GetLatestSchedulingJobsLatestGetData, GetLatestSchedulingJobsLatestGetError>
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<GetLatestSchedulingJobsLatestGetData, GetLatestSchedulingJobsLatestGetError>,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary Get Latest
     * @description Get the most recent scheduling job for the office.
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetLatestSchedulingJobsLatestGetSchema,
        GetLatestSchedulingJobsLatestGetData,
        GetLatestSchedulingJobsLatestGetParameters,
        GetLatestSchedulingJobsLatestGetError
      > | void
    ): Promise<GetLatestSchedulingJobsLatestGetData>;
    /**
     * @summary Get Latest
     * @description Get the most recent scheduling job for the office.
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetLatestSchedulingJobsLatestGetSchema,
        GetLatestSchedulingJobsLatestGetData,
        GetLatestSchedulingJobsLatestGetParameters,
        GetLatestSchedulingJobsLatestGetError
      > | void
    ): Promise<void>;
    /**
     * @summary Get Latest
     * @description Get the most recent scheduling job for the office.
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetLatestSchedulingJobsLatestGetSchema,
        GetLatestSchedulingJobsLatestGetData,
        GetLatestSchedulingJobsLatestGetParameters,
        GetLatestSchedulingJobsLatestGetError
      > | void
    ): Promise<GetLatestSchedulingJobsLatestGetData>;
    /**
     * @summary Get Latest
     * @description Get the most recent scheduling job for the office.
     */
    fetchInfiniteQuery<TPageParam extends GetLatestSchedulingJobsLatestGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetLatestSchedulingJobsLatestGetSchema,
        GetLatestSchedulingJobsLatestGetData,
        GetLatestSchedulingJobsLatestGetParameters,
        DeepReadonly<TPageParam>,
        GetLatestSchedulingJobsLatestGetError
      > | void
    ): Promise<OperationInfiniteData<GetLatestSchedulingJobsLatestGetData, GetLatestSchedulingJobsLatestGetParameters>>;
    /**
     * @summary Get Latest
     * @description Get the most recent scheduling job for the office.
     */
    prefetchInfiniteQuery<TPageParam extends GetLatestSchedulingJobsLatestGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetLatestSchedulingJobsLatestGetSchema,
        GetLatestSchedulingJobsLatestGetData,
        GetLatestSchedulingJobsLatestGetParameters,
        DeepReadonly<TPageParam>,
        GetLatestSchedulingJobsLatestGetError
      > | void
    ): Promise<void>;
    /**
     * @summary Get Latest
     * @description Get the most recent scheduling job for the office.
     */
    ensureInfiniteQueryData<TPageParam extends GetLatestSchedulingJobsLatestGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetLatestSchedulingJobsLatestGetSchema,
        GetLatestSchedulingJobsLatestGetData,
        GetLatestSchedulingJobsLatestGetParameters,
        DeepReadonly<TPageParam>,
        GetLatestSchedulingJobsLatestGetError
      > | void
    ): Promise<OperationInfiniteData<GetLatestSchedulingJobsLatestGetData, GetLatestSchedulingJobsLatestGetParameters>>;
    /**
     * @summary Get Latest
     * @description Get the most recent scheduling job for the office.
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<GetLatestSchedulingJobsLatestGetSchema, GetLatestSchedulingJobsLatestGetParameters>
        | (DeepReadonly<GetLatestSchedulingJobsLatestGetParameters> | void)
    ): GetLatestSchedulingJobsLatestGetData | undefined;
    /**
     * @summary Get Latest
     * @description Get the most recent scheduling job for the office.
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetLatestSchedulingJobsLatestGetSchema,
            GetLatestSchedulingJobsLatestGetParameters
          >
        | (DeepReadonly<GetLatestSchedulingJobsLatestGetParameters> | void)
    ):
      | OperationInfiniteData<GetLatestSchedulingJobsLatestGetData, GetLatestSchedulingJobsLatestGetParameters>
      | undefined;
    /**
     * @summary Get Latest
     * @description Get the most recent scheduling job for the office.
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetLatestSchedulingJobsLatestGetSchema,
            GetLatestSchedulingJobsLatestGetData,
            TInfinite,
            GetLatestSchedulingJobsLatestGetParameters,
            GetLatestSchedulingJobsLatestGetError
          >
        | QueryFiltersByQueryKey<
            GetLatestSchedulingJobsLatestGetSchema,
            GetLatestSchedulingJobsLatestGetData,
            TInfinite,
            GetLatestSchedulingJobsLatestGetParameters,
            GetLatestSchedulingJobsLatestGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              GetLatestSchedulingJobsLatestGetSchema,
              GetLatestSchedulingJobsLatestGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    GetLatestSchedulingJobsLatestGetData,
                    GetLatestSchedulingJobsLatestGetParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              GetLatestSchedulingJobsLatestGetSchema,
              GetLatestSchedulingJobsLatestGetParameters
            >,
            data: GetLatestSchedulingJobsLatestGetData | undefined,
          ]
        >;
    /**
     * @summary Get Latest
     * @description Get the most recent scheduling job for the office.
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<GetLatestSchedulingJobsLatestGetSchema, GetLatestSchedulingJobsLatestGetParameters>
        | (DeepReadonly<GetLatestSchedulingJobsLatestGetParameters> | void)
    ): QueryState<GetLatestSchedulingJobsLatestGetData, GetLatestSchedulingJobsLatestGetError> | undefined;
    /**
     * @summary Get Latest
     * @description Get the most recent scheduling job for the office.
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetLatestSchedulingJobsLatestGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetLatestSchedulingJobsLatestGetSchema,
            GetLatestSchedulingJobsLatestGetParameters
          >
        | void
    ):
      | QueryState<
          OperationInfiniteData<GetLatestSchedulingJobsLatestGetData, GetLatestSchedulingJobsLatestGetParameters>,
          GetLatestSchedulingJobsLatestGetError
        >
      | undefined;
    /**
     * @summary Get Latest
     * @description Get the most recent scheduling job for the office.
     */
    setQueryData(
      parameters:
        | (DeepReadonly<GetLatestSchedulingJobsLatestGetParameters> | undefined)
        | ServiceOperationQueryKey<GetLatestSchedulingJobsLatestGetSchema, GetLatestSchedulingJobsLatestGetParameters>,
      updater: Updater<
        NoInfer<GetLatestSchedulingJobsLatestGetData> | undefined,
        NoInfer<DeepReadonly<GetLatestSchedulingJobsLatestGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetLatestSchedulingJobsLatestGetData | undefined;
    /**
     * @summary Get Latest
     * @description Get the most recent scheduling job for the office.
     */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<GetLatestSchedulingJobsLatestGetParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<
            GetLatestSchedulingJobsLatestGetSchema,
            GetLatestSchedulingJobsLatestGetParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<GetLatestSchedulingJobsLatestGetData, GetLatestSchedulingJobsLatestGetParameters>
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<GetLatestSchedulingJobsLatestGetData, GetLatestSchedulingJobsLatestGetParameters>
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<GetLatestSchedulingJobsLatestGetData, GetLatestSchedulingJobsLatestGetParameters>
      | undefined;
    /**
     * @summary Get Latest
     * @description Get the most recent scheduling job for the office.
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetLatestSchedulingJobsLatestGetSchema,
            GetLatestSchedulingJobsLatestGetData,
            TInfinite,
            GetLatestSchedulingJobsLatestGetParameters,
            GetLatestSchedulingJobsLatestGetError
          >
        | QueryFiltersByQueryKey<
            GetLatestSchedulingJobsLatestGetSchema,
            GetLatestSchedulingJobsLatestGetData,
            TInfinite,
            GetLatestSchedulingJobsLatestGetParameters,
            GetLatestSchedulingJobsLatestGetError
          >,
      updater: Updater<
        NoInfer<GetLatestSchedulingJobsLatestGetData> | undefined,
        NoInfer<GetLatestSchedulingJobsLatestGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<GetLatestSchedulingJobsLatestGetData | undefined>;
    /**
     * @summary Get Latest
     * @description Get the most recent scheduling job for the office.
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetLatestSchedulingJobsLatestGetSchema,
        GetLatestSchedulingJobsLatestGetData,
        TInfinite,
        GetLatestSchedulingJobsLatestGetParameters,
        GetLatestSchedulingJobsLatestGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary Get Latest
     * @description Get the most recent scheduling job for the office.
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetLatestSchedulingJobsLatestGetSchema,
            GetLatestSchedulingJobsLatestGetData,
            TInfinite,
            GetLatestSchedulingJobsLatestGetParameters,
            GetLatestSchedulingJobsLatestGetError
          >
        | QueryFiltersByQueryKey<
            GetLatestSchedulingJobsLatestGetSchema,
            GetLatestSchedulingJobsLatestGetData,
            TInfinite,
            GetLatestSchedulingJobsLatestGetParameters,
            GetLatestSchedulingJobsLatestGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary Get Latest
     * @description Get the most recent scheduling job for the office.
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetLatestSchedulingJobsLatestGetSchema,
            GetLatestSchedulingJobsLatestGetData,
            TInfinite,
            GetLatestSchedulingJobsLatestGetParameters,
            GetLatestSchedulingJobsLatestGetError
          >
        | QueryFiltersByQueryKey<
            GetLatestSchedulingJobsLatestGetSchema,
            GetLatestSchedulingJobsLatestGetData,
            TInfinite,
            GetLatestSchedulingJobsLatestGetParameters,
            GetLatestSchedulingJobsLatestGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary Get Latest
     * @description Get the most recent scheduling job for the office.
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetLatestSchedulingJobsLatestGetSchema,
            GetLatestSchedulingJobsLatestGetData,
            TInfinite,
            GetLatestSchedulingJobsLatestGetParameters,
            GetLatestSchedulingJobsLatestGetError
          >
        | QueryFiltersByQueryKey<
            GetLatestSchedulingJobsLatestGetSchema,
            GetLatestSchedulingJobsLatestGetData,
            TInfinite,
            GetLatestSchedulingJobsLatestGetParameters,
            GetLatestSchedulingJobsLatestGetError
          >
    ): void;
    /**
     * @summary Get Latest
     * @description Get the most recent scheduling job for the office.
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetLatestSchedulingJobsLatestGetSchema,
            GetLatestSchedulingJobsLatestGetData,
            TInfinite,
            GetLatestSchedulingJobsLatestGetParameters,
            GetLatestSchedulingJobsLatestGetError
          >
        | QueryFiltersByQueryKey<
            GetLatestSchedulingJobsLatestGetSchema,
            GetLatestSchedulingJobsLatestGetData,
            TInfinite,
            GetLatestSchedulingJobsLatestGetParameters,
            GetLatestSchedulingJobsLatestGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary Get Latest
     * @description Get the most recent scheduling job for the office.
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetLatestSchedulingJobsLatestGetSchema,
            GetLatestSchedulingJobsLatestGetData,
            TInfinite,
            GetLatestSchedulingJobsLatestGetParameters,
            GetLatestSchedulingJobsLatestGetError
          >
        | QueryFiltersByQueryKey<
            GetLatestSchedulingJobsLatestGetSchema,
            GetLatestSchedulingJobsLatestGetData,
            TInfinite,
            GetLatestSchedulingJobsLatestGetParameters,
            GetLatestSchedulingJobsLatestGetError
          >
    ): number;
    schema: GetLatestSchedulingJobsLatestGetSchema;
    types: {
      parameters: GetLatestSchedulingJobsLatestGetParameters;
      data: GetLatestSchedulingJobsLatestGetData;
      error: GetLatestSchedulingJobsLatestGetError;
    };
  };
  /**
   * @summary Get
   * @description Get a specific scheduling job by ID.
   */
  getSchedulingJobsJobIdGet: {
    /**
     * @summary Get
     * @description Get a specific scheduling job by ID.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<GetSchedulingJobsJobIdGetSchema, GetSchedulingJobsJobIdGetParameters, TMeta, TSignal>
        | QueryFnOptionsByParameters<GetSchedulingJobsJobIdGetParameters, TMeta, TSignal>,
      client?: (
        schema: GetSchedulingJobsJobIdGetSchema,
        options: {
          parameters: GetSchedulingJobsJobIdGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<GetSchedulingJobsJobIdGetData, GetSchedulingJobsJobIdGetError>>
    ): Promise<RequestFnResponse<GetSchedulingJobsJobIdGetData, GetSchedulingJobsJobIdGetError>>;
    /**
     * @summary Get
     * @description Get a specific scheduling job by ID.
     */
    getQueryKey(
      parameters: DeepReadonly<GetSchedulingJobsJobIdGetParameters>
    ): ServiceOperationQueryKey<GetSchedulingJobsJobIdGetSchema, GetSchedulingJobsJobIdGetParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get
     * @description Get a specific scheduling job by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.schedulingService.getSchedulingJobsJobIdGet.useQuery({
     *     path: {
     *         job_id: jobId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetSchedulingJobsJobIdGetData>(
      parameters:
        | ServiceOperationQueryKey<GetSchedulingJobsJobIdGetSchema, GetSchedulingJobsJobIdGetParameters>
        | DeepReadonly<GetSchedulingJobsJobIdGetParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          GetSchedulingJobsJobIdGetData,
          GetSchedulingJobsJobIdGetError,
          TData,
          ServiceOperationQueryKey<GetSchedulingJobsJobIdGetSchema, GetSchedulingJobsJobIdGetParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetSchedulingJobsJobIdGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get
     * @description Get a specific scheduling job by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.schedulingService.getSchedulingJobsJobIdGet.useQuery({
     *     path: {
     *         job_id: jobId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetSchedulingJobsJobIdGetData>(
      parameters:
        | ServiceOperationQueryKey<GetSchedulingJobsJobIdGetSchema, GetSchedulingJobsJobIdGetParameters>
        | DeepReadonly<GetSchedulingJobsJobIdGetParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          GetSchedulingJobsJobIdGetData,
          GetSchedulingJobsJobIdGetError,
          TData,
          ServiceOperationQueryKey<GetSchedulingJobsJobIdGetSchema, GetSchedulingJobsJobIdGetParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetSchedulingJobsJobIdGetError>>;
    /**
     * @summary Get
     * @description Get a specific scheduling job by ID.
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetSchedulingJobsJobIdGetParameters>
    ): ServiceOperationInfiniteQueryKey<GetSchedulingJobsJobIdGetSchema, GetSchedulingJobsJobIdGetParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get
     * @description Get a specific scheduling job by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.schedulingService.getSchedulingJobsJobIdGet.useInfiniteQuery({
     *     path: {
     *         job_id: jobId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetSchedulingJobsJobIdGetParameters,
      TQueryFnData = GetSchedulingJobsJobIdGetData,
      TData = OperationInfiniteData<TQueryFnData, GetSchedulingJobsJobIdGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetSchedulingJobsJobIdGetSchema, GetSchedulingJobsJobIdGetParameters>
        | DeepReadonly<GetSchedulingJobsJobIdGetParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetSchedulingJobsJobIdGetError,
          TData,
          ServiceOperationInfiniteQueryKey<GetSchedulingJobsJobIdGetSchema, GetSchedulingJobsJobIdGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetSchedulingJobsJobIdGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get
     * @description Get a specific scheduling job by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.schedulingService.getSchedulingJobsJobIdGet.useInfiniteQuery({
     *     path: {
     *         job_id: jobId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetSchedulingJobsJobIdGetParameters,
      TQueryFnData = GetSchedulingJobsJobIdGetData,
      TData = OperationInfiniteData<TQueryFnData, GetSchedulingJobsJobIdGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetSchedulingJobsJobIdGetSchema, GetSchedulingJobsJobIdGetParameters>
        | DeepReadonly<GetSchedulingJobsJobIdGetParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetSchedulingJobsJobIdGetError,
          TData,
          ServiceOperationInfiniteQueryKey<GetSchedulingJobsJobIdGetSchema, GetSchedulingJobsJobIdGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetSchedulingJobsJobIdGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetSchedulingJobsJobIdGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get
     * @description Get a specific scheduling job by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getSchedulingJobsJobIdGetTotal = qraft.schedulingService.getSchedulingJobsJobIdGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const getSchedulingJobsJobIdGetByParametersTotal = qraft.schedulingService.getSchedulingJobsJobIdGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         path: {
     *             job_id: jobId
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetSchedulingJobsJobIdGetSchema,
            GetSchedulingJobsJobIdGetData,
            TInfinite,
            GetSchedulingJobsJobIdGetParameters,
            GetSchedulingJobsJobIdGetError
          >
        | QueryFiltersByQueryKey<
            GetSchedulingJobsJobIdGetSchema,
            GetSchedulingJobsJobIdGetData,
            TInfinite,
            GetSchedulingJobsJobIdGetParameters,
            GetSchedulingJobsJobIdGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get
     * @description Get a specific scheduling job by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getSchedulingJobsJobIdGetResults = qraft.schedulingService.getSchedulingJobsJobIdGet.useQueries({
     *     queries: [
     *         {
     *             path: {
     *                 job_id: jobId1
     *             }
     *         },
     *         {
     *             path: {
     *                 job_id: jobId2
     *             }
     *         }
     *     ]
     * });
     * getSchedulingJobsJobIdGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getSchedulingJobsJobIdGetCombinedResults = qraft.schedulingService.getSchedulingJobsJobIdGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 job_id: jobId1
     *             }
     *         },
     *         {
     *             path: {
     *                 job_id: jobId2
     *             }
     *         }
     *     ]
     * });
     * getSchedulingJobsJobIdGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetSchedulingJobsJobIdGetSchema,
          GetSchedulingJobsJobIdGetParameters,
          GetSchedulingJobsJobIdGetData,
          GetSchedulingJobsJobIdGetError
        >
      >,
      TCombinedResult = Array<UseQueryResult<GetSchedulingJobsJobIdGetData, GetSchedulingJobsJobIdGetError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<UseQueryResult<GetSchedulingJobsJobIdGetData, GetSchedulingJobsJobIdGetError>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get
     * @description Get a specific scheduling job by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.schedulingService.getSchedulingJobsJobIdGet.useSuspenseQuery({
     *     path: {
     *         job_id: jobId
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = GetSchedulingJobsJobIdGetData>(
      parameters:
        | ServiceOperationQueryKey<GetSchedulingJobsJobIdGetSchema, GetSchedulingJobsJobIdGetParameters>
        | DeepReadonly<GetSchedulingJobsJobIdGetParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          GetSchedulingJobsJobIdGetData,
          GetSchedulingJobsJobIdGetError,
          TData,
          ServiceOperationQueryKey<GetSchedulingJobsJobIdGetSchema, GetSchedulingJobsJobIdGetParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetSchedulingJobsJobIdGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get
     * @description Get a specific scheduling job by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.schedulingService.getSchedulingJobsJobIdGet.useSuspenseInfiniteQuery({
     *     path: {
     *         job_id: jobId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends GetSchedulingJobsJobIdGetParameters,
      TData = GetSchedulingJobsJobIdGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetSchedulingJobsJobIdGetSchema, GetSchedulingJobsJobIdGetParameters>
        | DeepReadonly<GetSchedulingJobsJobIdGetParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetSchedulingJobsJobIdGetData,
          GetSchedulingJobsJobIdGetError,
          OperationInfiniteData<TData, GetSchedulingJobsJobIdGetParameters>,
          ServiceOperationInfiniteQueryKey<GetSchedulingJobsJobIdGetSchema, GetSchedulingJobsJobIdGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetSchedulingJobsJobIdGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetSchedulingJobsJobIdGetParameters>,
      OperationError<GetSchedulingJobsJobIdGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get
     * @description Get a specific scheduling job by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getSchedulingJobsJobIdGetData = qraft.schedulingService.getSchedulingJobsJobIdGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             path: {
     *                 job_id: jobId1
     *             }
     *         },
     *         {
     *             path: {
     *                 job_id: jobId2
     *             }
     *         }
     *     ]
     * });
     * getSchedulingJobsJobIdGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getSchedulingJobsJobIdGetCombinedData = qraft.schedulingService.getSchedulingJobsJobIdGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 job_id: jobId1
     *             }
     *         },
     *         {
     *             path: {
     *                 job_id: jobId2
     *             }
     *         }
     *     ]
     * });
     * getSchedulingJobsJobIdGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetSchedulingJobsJobIdGetSchema,
          GetSchedulingJobsJobIdGetParameters,
          GetSchedulingJobsJobIdGetData,
          GetSchedulingJobsJobIdGetError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<GetSchedulingJobsJobIdGetData, GetSchedulingJobsJobIdGetError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<UseSuspenseQueryResult<GetSchedulingJobsJobIdGetData, GetSchedulingJobsJobIdGetError>, 'data'>
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary Get
     * @description Get a specific scheduling job by ID.
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetSchedulingJobsJobIdGetSchema,
        GetSchedulingJobsJobIdGetData,
        GetSchedulingJobsJobIdGetParameters,
        GetSchedulingJobsJobIdGetError
      >
    ): Promise<GetSchedulingJobsJobIdGetData>;
    /**
     * @summary Get
     * @description Get a specific scheduling job by ID.
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetSchedulingJobsJobIdGetSchema,
        GetSchedulingJobsJobIdGetData,
        GetSchedulingJobsJobIdGetParameters,
        GetSchedulingJobsJobIdGetError
      >
    ): Promise<void>;
    /**
     * @summary Get
     * @description Get a specific scheduling job by ID.
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetSchedulingJobsJobIdGetSchema,
        GetSchedulingJobsJobIdGetData,
        GetSchedulingJobsJobIdGetParameters,
        GetSchedulingJobsJobIdGetError
      >
    ): Promise<GetSchedulingJobsJobIdGetData>;
    /**
     * @summary Get
     * @description Get a specific scheduling job by ID.
     */
    fetchInfiniteQuery<TPageParam extends GetSchedulingJobsJobIdGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetSchedulingJobsJobIdGetSchema,
        GetSchedulingJobsJobIdGetData,
        GetSchedulingJobsJobIdGetParameters,
        DeepReadonly<TPageParam>,
        GetSchedulingJobsJobIdGetError
      >
    ): Promise<OperationInfiniteData<GetSchedulingJobsJobIdGetData, GetSchedulingJobsJobIdGetParameters>>;
    /**
     * @summary Get
     * @description Get a specific scheduling job by ID.
     */
    prefetchInfiniteQuery<TPageParam extends GetSchedulingJobsJobIdGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetSchedulingJobsJobIdGetSchema,
        GetSchedulingJobsJobIdGetData,
        GetSchedulingJobsJobIdGetParameters,
        DeepReadonly<TPageParam>,
        GetSchedulingJobsJobIdGetError
      >
    ): Promise<void>;
    /**
     * @summary Get
     * @description Get a specific scheduling job by ID.
     */
    ensureInfiniteQueryData<TPageParam extends GetSchedulingJobsJobIdGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetSchedulingJobsJobIdGetSchema,
        GetSchedulingJobsJobIdGetData,
        GetSchedulingJobsJobIdGetParameters,
        DeepReadonly<TPageParam>,
        GetSchedulingJobsJobIdGetError
      >
    ): Promise<OperationInfiniteData<GetSchedulingJobsJobIdGetData, GetSchedulingJobsJobIdGetParameters>>;
    /**
     * @summary Get
     * @description Get a specific scheduling job by ID.
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<GetSchedulingJobsJobIdGetSchema, GetSchedulingJobsJobIdGetParameters>
        | DeepReadonly<GetSchedulingJobsJobIdGetParameters>
    ): GetSchedulingJobsJobIdGetData | undefined;
    /**
     * @summary Get
     * @description Get a specific scheduling job by ID.
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetSchedulingJobsJobIdGetSchema, GetSchedulingJobsJobIdGetParameters>
        | DeepReadonly<GetSchedulingJobsJobIdGetParameters>
    ): OperationInfiniteData<GetSchedulingJobsJobIdGetData, GetSchedulingJobsJobIdGetParameters> | undefined;
    /**
     * @summary Get
     * @description Get a specific scheduling job by ID.
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetSchedulingJobsJobIdGetSchema,
            GetSchedulingJobsJobIdGetData,
            TInfinite,
            GetSchedulingJobsJobIdGetParameters,
            GetSchedulingJobsJobIdGetError
          >
        | QueryFiltersByQueryKey<
            GetSchedulingJobsJobIdGetSchema,
            GetSchedulingJobsJobIdGetData,
            TInfinite,
            GetSchedulingJobsJobIdGetParameters,
            GetSchedulingJobsJobIdGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              GetSchedulingJobsJobIdGetSchema,
              GetSchedulingJobsJobIdGetParameters
            >,
            data:
              | NoInfer<OperationInfiniteData<GetSchedulingJobsJobIdGetData, GetSchedulingJobsJobIdGetParameters>>
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<GetSchedulingJobsJobIdGetSchema, GetSchedulingJobsJobIdGetParameters>,
            data: GetSchedulingJobsJobIdGetData | undefined,
          ]
        >;
    /**
     * @summary Get
     * @description Get a specific scheduling job by ID.
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<GetSchedulingJobsJobIdGetSchema, GetSchedulingJobsJobIdGetParameters>
        | DeepReadonly<GetSchedulingJobsJobIdGetParameters>
    ): QueryState<GetSchedulingJobsJobIdGetData, GetSchedulingJobsJobIdGetError> | undefined;
    /**
     * @summary Get
     * @description Get a specific scheduling job by ID.
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetSchedulingJobsJobIdGetParameters>
        | ServiceOperationInfiniteQueryKey<GetSchedulingJobsJobIdGetSchema, GetSchedulingJobsJobIdGetParameters>
    ):
      | QueryState<
          OperationInfiniteData<GetSchedulingJobsJobIdGetData, GetSchedulingJobsJobIdGetParameters>,
          GetSchedulingJobsJobIdGetError
        >
      | undefined;
    /**
     * @summary Get
     * @description Get a specific scheduling job by ID.
     */
    setQueryData(
      parameters:
        | DeepReadonly<GetSchedulingJobsJobIdGetParameters>
        | ServiceOperationQueryKey<GetSchedulingJobsJobIdGetSchema, GetSchedulingJobsJobIdGetParameters>,
      updater: Updater<
        NoInfer<GetSchedulingJobsJobIdGetData> | undefined,
        NoInfer<DeepReadonly<GetSchedulingJobsJobIdGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetSchedulingJobsJobIdGetData | undefined;
    /**
     * @summary Get
     * @description Get a specific scheduling job by ID.
     */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<GetSchedulingJobsJobIdGetParameters>
        | ServiceOperationInfiniteQueryKey<GetSchedulingJobsJobIdGetSchema, GetSchedulingJobsJobIdGetParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<GetSchedulingJobsJobIdGetData, GetSchedulingJobsJobIdGetParameters>> | undefined,
        | NoInfer<
            DeepReadonly<OperationInfiniteData<GetSchedulingJobsJobIdGetData, GetSchedulingJobsJobIdGetParameters>>
          >
        | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<GetSchedulingJobsJobIdGetData, GetSchedulingJobsJobIdGetParameters> | undefined;
    /**
     * @summary Get
     * @description Get a specific scheduling job by ID.
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetSchedulingJobsJobIdGetSchema,
            GetSchedulingJobsJobIdGetData,
            TInfinite,
            GetSchedulingJobsJobIdGetParameters,
            GetSchedulingJobsJobIdGetError
          >
        | QueryFiltersByQueryKey<
            GetSchedulingJobsJobIdGetSchema,
            GetSchedulingJobsJobIdGetData,
            TInfinite,
            GetSchedulingJobsJobIdGetParameters,
            GetSchedulingJobsJobIdGetError
          >,
      updater: Updater<
        NoInfer<GetSchedulingJobsJobIdGetData> | undefined,
        NoInfer<GetSchedulingJobsJobIdGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<GetSchedulingJobsJobIdGetData | undefined>;
    /**
     * @summary Get
     * @description Get a specific scheduling job by ID.
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetSchedulingJobsJobIdGetSchema,
        GetSchedulingJobsJobIdGetData,
        TInfinite,
        GetSchedulingJobsJobIdGetParameters,
        GetSchedulingJobsJobIdGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary Get
     * @description Get a specific scheduling job by ID.
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetSchedulingJobsJobIdGetSchema,
            GetSchedulingJobsJobIdGetData,
            TInfinite,
            GetSchedulingJobsJobIdGetParameters,
            GetSchedulingJobsJobIdGetError
          >
        | QueryFiltersByQueryKey<
            GetSchedulingJobsJobIdGetSchema,
            GetSchedulingJobsJobIdGetData,
            TInfinite,
            GetSchedulingJobsJobIdGetParameters,
            GetSchedulingJobsJobIdGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary Get
     * @description Get a specific scheduling job by ID.
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetSchedulingJobsJobIdGetSchema,
            GetSchedulingJobsJobIdGetData,
            TInfinite,
            GetSchedulingJobsJobIdGetParameters,
            GetSchedulingJobsJobIdGetError
          >
        | QueryFiltersByQueryKey<
            GetSchedulingJobsJobIdGetSchema,
            GetSchedulingJobsJobIdGetData,
            TInfinite,
            GetSchedulingJobsJobIdGetParameters,
            GetSchedulingJobsJobIdGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary Get
     * @description Get a specific scheduling job by ID.
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetSchedulingJobsJobIdGetSchema,
            GetSchedulingJobsJobIdGetData,
            TInfinite,
            GetSchedulingJobsJobIdGetParameters,
            GetSchedulingJobsJobIdGetError
          >
        | QueryFiltersByQueryKey<
            GetSchedulingJobsJobIdGetSchema,
            GetSchedulingJobsJobIdGetData,
            TInfinite,
            GetSchedulingJobsJobIdGetParameters,
            GetSchedulingJobsJobIdGetError
          >
    ): void;
    /**
     * @summary Get
     * @description Get a specific scheduling job by ID.
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetSchedulingJobsJobIdGetSchema,
            GetSchedulingJobsJobIdGetData,
            TInfinite,
            GetSchedulingJobsJobIdGetParameters,
            GetSchedulingJobsJobIdGetError
          >
        | QueryFiltersByQueryKey<
            GetSchedulingJobsJobIdGetSchema,
            GetSchedulingJobsJobIdGetData,
            TInfinite,
            GetSchedulingJobsJobIdGetParameters,
            GetSchedulingJobsJobIdGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary Get
     * @description Get a specific scheduling job by ID.
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetSchedulingJobsJobIdGetSchema,
            GetSchedulingJobsJobIdGetData,
            TInfinite,
            GetSchedulingJobsJobIdGetParameters,
            GetSchedulingJobsJobIdGetError
          >
        | QueryFiltersByQueryKey<
            GetSchedulingJobsJobIdGetSchema,
            GetSchedulingJobsJobIdGetData,
            TInfinite,
            GetSchedulingJobsJobIdGetParameters,
            GetSchedulingJobsJobIdGetError
          >
    ): number;
    schema: GetSchedulingJobsJobIdGetSchema;
    types: {
      parameters: GetSchedulingJobsJobIdGetParameters;
      data: GetSchedulingJobsJobIdGetData;
      error: GetSchedulingJobsJobIdGetError;
    };
  };
}
/**
 * @summary Submit
 * @description Submit a new scheduling job.
 *
 * Date validation is performed by SchedulingJobParams schema.
 * In-progress check is performed by submit_scheduling_job service.
 */
export const submitSchedulingJobsPost = {
  schema: {
    method: 'post',
    url: '/scheduling/jobs',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: SubmitSchedulingJobsPostSchema;
  [QraftServiceOperationsToken]: SchedulingService['submitSchedulingJobsPost'];
};
/**
 * @summary Get Latest
 * @description Get the most recent scheduling job for the office.
 */
export const getLatestSchedulingJobsLatestGet = {
  schema: {
    method: 'get',
    url: '/scheduling/jobs/latest',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetLatestSchedulingJobsLatestGetSchema;
  [QraftServiceOperationsToken]: SchedulingService['getLatestSchedulingJobsLatestGet'];
};
/**
 * @summary Get
 * @description Get a specific scheduling job by ID.
 */
export const getSchedulingJobsJobIdGet = {
  schema: {
    method: 'get',
    url: '/scheduling/jobs/{job_id}',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetSchedulingJobsJobIdGetSchema;
  [QraftServiceOperationsToken]: SchedulingService['getSchedulingJobsJobIdGet'];
};
export const schedulingService = {
  submitSchedulingJobsPost,
  getLatestSchedulingJobsLatestGet,
  getSchedulingJobsJobIdGet,
} as const;
type SubmitSchedulingJobsPostSchema = {
  method: 'post';
  url: '/scheduling/jobs';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type SubmitSchedulingJobsPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type SubmitSchedulingJobsPostData =
  paths['/scheduling/jobs']['post']['responses']['201']['content']['application/json'];
type SubmitSchedulingJobsPostError =
  paths['/scheduling/jobs']['post']['responses']['422']['content']['application/json'];
type SubmitSchedulingJobsPostBody = paths['/scheduling/jobs']['post']['requestBody']['content']['application/json'];
type GetLatestSchedulingJobsLatestGetSchema = {
  method: 'get';
  url: '/scheduling/jobs/latest';
  security: ['HTTPBearer'];
};
type GetLatestSchedulingJobsLatestGetParameters = undefined;
type GetLatestSchedulingJobsLatestGetData =
  paths['/scheduling/jobs/latest']['get']['responses']['200']['content']['application/json'];
type GetLatestSchedulingJobsLatestGetError = unknown;
type GetSchedulingJobsJobIdGetSchema = {
  method: 'get';
  url: '/scheduling/jobs/{job_id}';
  security: ['HTTPBearer'];
};
type GetSchedulingJobsJobIdGetParameters = paths['/scheduling/jobs/{job_id}']['get']['parameters'];
type GetSchedulingJobsJobIdGetData =
  paths['/scheduling/jobs/{job_id}']['get']['responses']['200']['content']['application/json'];
type GetSchedulingJobsJobIdGetError =
  paths['/scheduling/jobs/{job_id}']['get']['responses']['422']['content']['application/json'];
